import React from "react";
export function SidebarMobileToggle() {
  return (
    <button
      id="sidebarToggleTop"
      className="btn btn-link d-md-none rounded-circle mr-3"
    >
      <i className="fa fa-bars" />
    </button>
  );
}
